import { Action, createReducer, on } from '@ngrx/store';
import {
    loadEventLogDetails,
    loadEventLogDetailsCompletion,
    loadEventLogDetailsSuccess,
    loadRecordLogs,
    loadRecordLogsSuccess,
    loadRecordLogsCompletion
} from './integration-event-log-details.actions';
import { IntegrationEventLogDetails } from '../../models/integration-event-log-details';
import { IntegrationRecordLogsDetails } from '../../models/integration-record-log-details.model';

export interface IntegrationEventLogDetailsState {
    eventLogDetails: IntegrationEventLogDetails;
    isLoading: boolean;

    recordLogs: IntegrationRecordLogsDetails | null;
    isRecordLogsLoading: boolean;
}

export const initialState: IntegrationEventLogDetailsState = {
    eventLogDetails: {
        instrumentationId: '',
        inputData: [],
        fileFullPaths: [],
        successRecords: [],
        errorRecords: [],
        unmodifiedRecords: []
    },
    isLoading: false,

    recordLogs: null,
    isRecordLogsLoading: false
};

export const integrationEventLogDetailsReducer = (
    reducerState: IntegrationEventLogDetailsState,
    reducerAction: Action
): IntegrationEventLogDetailsState => {
    return createReducer(
        initialState,
        on(
            loadEventLogDetails,
            (state): IntegrationEventLogDetailsState => ({
                ...state,
                isLoading: true
            })
        ),
        on(
            loadEventLogDetailsSuccess,
            (state, action): IntegrationEventLogDetailsState => ({
                ...state,
                isLoading: false,
                eventLogDetails: action.eventLogDetails
            })
        ),
        on(
            loadEventLogDetailsCompletion,
            (state): IntegrationEventLogDetailsState => ({
                ...state,
                isLoading: false
            })
        ),
        on(
            loadRecordLogs,
            (state): IntegrationEventLogDetailsState => ({
                ...state,
                isRecordLogsLoading: true,
                recordLogs: null
            })
        ),

        on(
            loadRecordLogsSuccess,
            (state, action): IntegrationEventLogDetailsState => ({
                ...state,
                isRecordLogsLoading: false,
                recordLogs: {
                    ...action.recordLogs,
                    logs: action.recordLogs.logs ?? [],
                    changes: action.recordLogs.changes ?? [],
                    errors: action.recordLogs.errors ?? []
                }
            })
        ),

        on(
            loadRecordLogsCompletion,
            (state): IntegrationEventLogDetailsState => ({
                ...state,
                isRecordLogsLoading: false
            })
        )
    )(reducerState, reducerAction);
};
